<template>
<div>

            <v-alert
                v-model="error"
                type="error"
                dismissible>An error has occured while performing a search</v-alert>

            <v-layout wrap pb-2>
                <v-flex sm2 d-flex>
                <v-select
                  clearable              
                  v-model="selectedSavedSearch"   
                  @change="selectSavedSearch"
                  :items="savedSearches"
                  item-text="Name"
                  item-value="Id"
                  label="Featured searches"
                ></v-select>
                </v-flex>
            </v-layout>

            <vue-query-builder :rules="sortedRules" :labels="labels" v-model="query" :max-depth="2"></vue-query-builder>

            <div class="form-group" style="margin-bottom: 1rem;">
                <v-btn color="primary" @click="search">Search</v-btn>
                <v-btn @click="clear">Clear</v-btn>
                <v-btn @click="downloadCsv" style="float: right;" :loading="loadingCsv">Download CSV</v-btn>
            </div>

            <h2 class="mb-1">Columns</h2>
            <v-autocomplete :items="headers" :value="headersSelectedWithExtra" @input="addHeaders($event)"  return-object label="Select headers"
             multiple chips solo flat></v-autocomplete>

            <br/>

            <v-data-table
                v-if="initialSearch"
                :headers="headersWithAction"
                :items="results"
                :pagination.sync="options"
                :total-items="totalCount"
                :loading="loading"
                :rows-per-page-items="[10, 20, 100, 500, 1000, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }]"
                :disable-initial-sort="true"
                >
                <template v-slot:items="props">
                    <template v-for="header in headersWithAction">
                        <td :key="header.value" v-if="header.value === 'order'"
                        class="text-xs-left">{{ props.item.Order}}</td>
                        <td :key="header.value" v-if="header.value === 'id'"
                        class="text-xs-left">{{ props.item.Id}}</td>
                        <td :key="header.value" v-if="header.value === 'photo'"
                        class="text-xs-left" style="width: 80px"><Portrait v-bind:PHID="props.item.Phid" :fixedWidth="50"></Portrait></td>                        
                        <td :key="header.value" v-if="header.value === 'phid'"
                        class="text-xs-left">{{ props.item.Phid }}</td>
                        <td :key="header.value" v-if="header.value === 'parliament'"
                        class="text-xs-left">{{ props.item.Parliament }}</td>
                        <td :key="header.value" v-if="header.value === 'givenName'"
                        class="text-xs-left">{{ props.item.GivenName }}</td>
                        <td :key="header.value" v-if="header.value === 'preferredName'"
                        class="text-xs-left">{{ props.item.PreferredName }}</td>
                        <td :key="header.value" v-if="header.value === 'familyName'"
                        class="text-xs-left">{{ props.item.FamilyName }}</td>
                        <td :key="header.value" v-if="header.value === 'middleNames'"
                        class="text-xs-left">{{ props.item.MiddleNames }}</td>   
                        <td :key="header.value" v-if="header.value === 'displayName'"
                        class="text-xs-left">{{ props.item.DisplayName }}</td>    
                        <td :key="header.value" v-if="header.value === 'gender'"
                        class="text-xs-left">{{ props.item.Gender }}</td>
                        <td :key="header.value" v-if="header.value === 'secondarySchool'"
                        class="text-xs-left">{{ props.item.SecondarySchool }}</td>       
                        <td :key="header.value" v-if="header.value === 'placeOfBirth'"
                        class="text-xs-left">{{ props.item.PlaceOfBirth }}</td>   
                        <td :key="header.value" v-if="header.value === 'placeOfDeath'"
                        class="text-xs-left">{{ props.item.PlaceOfDeath }}</td>        
                        <td :key="header.value" v-if="header.value === 'countryOfBirth'"
                        class="text-xs-left">{{ props.item.CountryOfBirth }}</td>  
                        <td :key="header.value" v-if="header.value === 'stateOfBirth'"
                        class="text-xs-left">{{ props.item.StateOfBirth }}</td>
                        <td :key="header.value" v-if="header.value === 'stateOfDeath'"
                        class="text-xs-left">{{ props.item.StateOfDeath }}</td>    
                        <td :key="header.value" v-if="header.value === 'maritalStatus'"
                        class="text-xs-left">{{ props.item.MaritalStatus }}</td>
                        <td :key="header.value" v-if="header.value === 'dateOfBirth'"
                        class="text-xs-left">{{ props.item.DateOfBirth }}</td>  
                        <td :key="header.value" v-if="header.value === 'dateOfDeath'"
                        class="text-xs-left">{{ props.item.DateOfDeath }}</td>                                                                                                                                     
                        <td :key="header.value" v-if="header.value === 'party.new'"
                        class="text-xs-left">{{ props.item.PartyNew }}</td>
                        <td :key="header.value" v-if="header.value === 'state'"
                        class="text-xs-left">{{ props.item.State }}</td>
                        <td :key="header.value" v-if="header.value === 'electorate'"
                        class="text-xs-left">{{ props.item.Electorate }}</td>
                        <td :key="header.value" v-if="header.value === 'mpOrSenator'"
                        class="text-xs-left">{{ props.item.MpOrSenator }}</td>                                              
                        <td :key="header.value" v-if="header.value === 'inCurrentParliament'"
                        class="text-xs-left">{{ props.item.InCurrentParliament | boolToYesOrNo }}</td>
                        <td :key="header.value" v-if="header.value === 'firstnations'"
                        class="text-xs-left">{{ props.item.FirstNations | boolToYesOrNo }} {{ props.item.FirstNationsText !== null ?  ' - ' + props.item.FirstNationsText : ''}}</td>
                        <td :key="header.value" v-if="header.value === 'ageInDays'"
                        class="text-xs-left">{{ props.item.AgeInDays === null ? 'Not stated' : props.item.Age }}</td>
                        <td :key="header.value" v-if="header.value === 'daysServed'"
                        class="text-xs-left">{{ props.item.DaysServed }}</td>  
                        <td :key="header.value" v-if="header.value === 'yearsServed'"
                        class="text-xs-left">{{ props.item.YearsServed }}</td>
                        <td :key="header.value" v-if="header.value === 'electedMemberNo'"
                        class="text-xs-left">{{ props.item.ElectedMemberNo }}</td>
                        <td :key="header.value" v-if="header.value === 'electedSenatorNo'"
                        class="text-xs-left">{{ props.item.ElectedSenatorNo }}</td>  
                        <td :key="header.value" v-if="header.value === 'acting.ministries'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['acting.ministries']" :key="i.Id">{{ STRING_COALESCE(i.Text1).trimEndChar('.') + DATE_FROMTO(i.DateStart1, i.DateEnd1) }}</li>
                            </ul>
                        </td>
                        <td :key="header.value" v-if="header.value === 'committee.service.records'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['committee.service.records']" :key="i.Id">{{ i.Type + ' - ' + i.Name + '. ' + i.ServiceDatesString }}</li>
                            </ul>
                        </td>
                        <td :key="header.value" v-if="header.value === 'conf.delegations.visits'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['conf.delegations.visits']" :key="i.Id">{{ STRING_COALESCE(i.Text1, ' ').trimEndChar('.') + '.' }}</li>
                            </ul>
                        </td>
                        <td :key="header.value" v-if="header.value === 'decorations'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['decorations']" :key="i.Id">{{ STRING_COALESCE(i.Text1, ' ').trimEndChar('.') + '.' }}</li>
                            </ul>
                        </td> 
                        <td :key="header.value" v-if="header.value === 'honours'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['honours']" :key="i.Id">{{ STRING_COALESCE(i.Text1, ' ').trimEndChar('.') + '.' }}</li>
                            </ul>
                        </td>   
                        <td :key="header.value" v-if="header.value === 'government.service.local'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['government.service.local']" :key="i.Id">{{ i.Text1 + STRING_COALESCE(i.Value1, ' ').trimEndChar('.') + DATE_FROMTO(i.DateStart1, i.DateEnd1) }}</li>
                            </ul>
                        </td> 
                        <td :key="header.value" v-if="header.value === 'military.service'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['military.service']" :key="i.Id">{{ STRING_COALESCE(i.Text1, ' ').trimEndChar('.') + '.' }}</li>
                            </ul>
                        </td>  
                        <td :key="header.value" v-if="header.value === 'ministerial.appointments'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['ministerial.appointments']" :key="i.Id">{{ STRING_COALESCE(i.Value1) + STRING_COALESCE(i.Value2, ' ') + STRING_COALESCE(i.Text1, ' ') + STRING_COALESCE(i.Value3, ' ').trimEndChar('.') + DATE_FROMTO(i.DateStart1, i.DateEnd1) }}</li>
                            </ul>
                        </td>
                        <td :key="header.value" v-if="header.value === 'misc.info'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['misc.info']" :key="i.Id">{{ STRING_COALESCE(i.Text1, ' ').trimEndChar('.') + DATE_FROMTO(i.DateStart1, i.DateEnd1) }}</li>
                            </ul>
                        </td>
                        <td :key="header.value" v-if="header.value === 'occupations'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['occupations']" :key="i.Id">{{ STRING_COALESCE(i.Text1, ' ').trimEndChar('.') + DATE_FROMTO(i.DateStart1, i.DateEnd1) }}</li>
                            </ul>
                        </td> 
                        <td :key="header.value" v-if="header.value === 'other.positions'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['other.positions']" :key="i.Id">{{ STRING_COALESCE(i.Text1, ' ').trimEndChar('.') + DATE_FROMTO(i.DateStart1, i.DateEnd1) }}</li>
                            </ul>
                        </td> 
                        <td :key="header.value" v-if="header.value === 'parliamentary.appointments'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['parliamentary.appointments']" :key="i.Id">{{ STRING_COALESCE(i.Text1, ' ').trimEndChar('.') + DATE_FROMTO(i.DateStart1, i.DateEnd1) }}</li>
                            </ul>
                        </td>  
                        <td :key="header.value" v-if="header.value === 'parliamentary.party.positions'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['parliamentary.party.positions']" :key="i.Id">{{ STRING_COALESCE(i.Value1) + STRING_COALESCE(i.Value2, ' ') + STRING_COALESCE(i.Value3, ' ') + (i.Text1 ? i.Text1.trimEndChar('.') : '') + DATE_FROMTO(i.DateStart1, i.DateEnd1) }}</li>
                            </ul>
                        </td>  
                        <td :key="header.value" v-if="header.value === 'parliamentary.positions'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['parliamentary.positions']" :key="i.Id">{{ STRING_COALESCE(i.Value1) + STRING_COALESCE(i.Text1, ' ').trimEndChar('.') + DATE_FROMTO(i.DateStart1, i.DateEnd1) }}</li>
                            </ul>
                        </td>  
                        <td :key="header.value" v-if="header.value === 'parliamentary.service'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['parliamentary.service']" :key="i.Id">{{ STRING_COALESCE(i.Value1) + STRING_COALESCE(i.Value2, ' ') + STRING_COALESCE(i.Text1, ' ').trimEndChar('.') + DATE_FROMTO(i.DateStart1, i.DateEnd1) }}</li>
                            </ul>
                        </td> 
                        <td :key="header.value" v-if="header.value === 'parties.represented.new'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['parties.represented.new']" :key="i.Id">{{ i.Value1 }}</li>
                            </ul>
                        </td>
                        <td :key="header.value" v-if="header.value === 'party.positions'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['party.positions']" :key="i.Id">{{ STRING_COALESCE(i.Value1) + STRING_COALESCE(i.Text1, ' ').trimEndChar('.') + DATE_FROMTO(i.DateStart1, i.DateEnd1) }}</li>
                            </ul>
                        </td>  
                        <td :key="header.value" v-if="header.value === 'publications'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['publications']" :key="i.Id">{{ STRING_COALESCE(i.Text1) + STRING_COALESCE(i.Text2, ' ') + STRING_COALESCE(i.Text3, ' ').trimEndChar('.') + ' ' + $moment(i.DateStart1).year() + '.' }}</li>
                            </ul>
                        </td>  
                        <td :key="header.value" v-if="header.value === 'quals.work.pre.parliament'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['quals.work.pre.parliament']" :key="i.Id">{{ STRING_COALESCE(i.Value2) + STRING_COALESCE(i.Value3, ', ').trimEndChar('.') + (DATE_COALESCE(i.DateStart1) !== '' ? ` ${$moment(i.DateStart1).year()}.` : '.') }}</li>
                            </ul>
                        </td> 
                        <td :key="header.value" v-if="header.value === 'shadow.ministry.appointments'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['shadow.ministry.appointments']" :key="i.Id">{{ STRING_COALESCE(i.Value1) + STRING_COALESCE(i.Value2, ' ') + STRING_COALESCE(i.Text1, ' ') + STRING_COALESCE(i.Value3, ' ').trimEndChar('.') + DATE_FROMTO(i.DateStart1, i.DateEnd1) }}</li>
                            </ul>
                        </td> 
                        <td :key="header.value" v-if="header.value === 'government.service.state'"
                        class="text-xs-left">
                            <ul>
                                <li v-for="i in props.item['government.service.state']" :key="i.Id">{{ STRING_COALESCE(i.Value1) + STRING_COALESCE(i.Text1, ' ') + STRING_COALESCE(i.Text2, ' ').trimEndChar('.') + DATE_FROMTO(i.DateStart1, i.DateEnd1) }}</li>
                            </ul>
                        </td>                                                                                                                                                                                                                                                                                                                                                                                                                           
                    </template>  
                    <td class="text-xs-left"><v-btn :to="'/Parliamentarian/' + props.item.Phid" small>View</v-btn></td>
                </template>                                                                                             
            </v-data-table>
   <br /> <br />
            </div>
          
</template>

<script>
    import axios from 'axios'
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;
    import Portrait from '@/components/Portrait.vue'

    import HandbookAPI from '@/mixins/HandbookAPI'


    import Vue from 'vue';
    import VueQueryBuilder from 'vue-query-builder';

    import moment from 'moment';

    String.prototype.trimEndChar = function (char) {
        if (this.toString().endsWith(char)) {
            return this.toString().substring(0, this.toString().length - 1).trimEndChar(char);
        } else {
            return this.toString();
        }
    }
    
    const defaultColumns = [ 'photo', 'phid', 'givenName', 'preferredName', 'familyName', 'mpOrSenator', 'inCurrentParliament', 'actions' ];

    const referenceLookup = nameId => ({
        template: `<v-autocomplete :loading="loading" :items="items" solo :value="value" @input="$emit('input', $event)"></v-autocomplete>`,
        props: ["value"],
        data: function () {
            return {
                loading: false,
                items: [],
                search: null,
                select: null
            }
        },
        created: function() {
            this.query();
        },
        methods: {
            query() {
                axios.get(`/api/reference?nameId=${nameId}`)
                    .then(response => {
                        this.items = response.data.map(d => ({ value: d.Id, text: d.Value }));
                        this.loading = false;
                    });
            }
        }
    });

    const parliamentarianReferenceLookup = field => ({
        template: `<v-combobox :loading="loading" :items="items" solo :value="value" @input="$emit('input', $event)"></v-combobox>`,
        props: ["value"],
        data: function () {
            return {
                loading: true,
                items: [],
                search: null,
                select: null
            }
        },
        created: function() {
            this.query();
        },
        methods: {
            query() {
                axios.get(`/api/reference/ParliamentarianLookup?field=${field}`)
                    .then(response => {
                        this.items = response.data;
                        this.loading = false;
                    });
            }
        }
    });        

    const parliamentLookup = {
        template: `<v-autocomplete :loading="loading" :items="items" solo :value="value" label="Parliament" @input="$emit('input', $event)"></v-autocomplete>`,
        props: ["value"],
        data: function () {
            return {
                loading: false,
                items: [],
                search: null,
                select: null
            }
        },
        created: function() {
            this.query();
        },
        methods: {
            query() {
                axios.get(`/api/reference/parliaments`)
                        .then(response => {
                            this.items = response
                                .data
                                .map(d => ({ 
                                    value: d.Id, 
                                    text: `${d.Name} (${d.DateOpening && new Date(d.DateOpening).toLocaleDateString()} to ${(d.DateDissolution
                                     && new Date(d.DateDissolution).toLocaleDateString()) || 'present' })`,
                                }));
                            this.loading = false;
                        });
            }
        }
    }       
    
    const parliamentLookupDateRange = {            
        template: `<v-autocomplete :loading="loading" :items="items" solo :value="value" label="Parliament" @input="emitValue($event)"></v-autocomplete>`,            
        props: ['value'],
        data: function () {
            return {
                loading: false,                    
                items: [],
                search: null,
                select: null
            }
        },
        created: function() {
            this.query();
        },
        methods: {
            query() {
                axios.get(`/api/reference/parliaments`)
                    .then(response => {
                        this.items = response.data.map(d => 
                            ({ 
                                value: d.Id, 
                                text: `${d.Name} (${d.DateOpening && new Date(d.DateOpening).toLocaleDateString()} to ${(d.DateDissolution 
                                && new Date(d.DateDissolution).toLocaleDateString()) || 'present' })`,
                                dateOpening: moment(new Date(d.DateOpening)).format("YYYY-MM-DD"),
                                dateDissolution: d.DateDissolution == null ? null : moment(new Date(d.DateDissolution)).format("YYYY-MM-DD")
                            }));
                        this.loading = false;
                    });
            },
            emitValue($event) {
                $event;
                const parliament = this.items.find(i => i.value === $event);
                this.$emit('input', parliament);
            }
        }
    }
    Vue.component('parliament-lookup', parliamentLookupDateRange);

    const ministryLookupDateRange = {            
        template: `<v-autocomplete allow-overflow :loading="loading" :items="items" solo :value="value" label="Ministry" @input="emitValue($event)"></v-autocomplete>`,
        props: ['value'],
        data: function () {
            return {
                loading: false,                    
                items: [],
                search: null,
                select: null
            }
        },
        created: function() {
            this.query();
        },
        methods: {
            query() {
                axios.get(`/api/reference/ministries`)
                        .then(response => {
                            this.items = response.data.map(d => 
                            ({ 
                                value: d.id,
                                text: `${d.Value} (${moment(new Date(d.DateStart)).format("DD/MM/YYYY")} to ${d.DateEnd == null ? 'present' : moment(new Date(d.DateEnd)).format("DD/MM/YYYY") })`, 
                                dateStart: moment(new Date(d.DateStart)).format("YYYY-MM-DD"),
                                dateEnd: d.DateEnd == null ? null : moment(new Date(d.DateEnd)).format("YYYY-MM-DD")
                            }));
                            this.loading = false;
                        });
            },
            emitValue($event) {              
                const ministry = this.items.find(i => i.text === $event);
                this.$emit('input', ministry);
            }
        }
    }
    Vue.component('ministry-lookup', ministryLookupDateRange);

    const calculateExtraHeaders = (query, headers) => {
        query.children.map(c => {
                    switch(c.type) {
                        case 'query-builder-rule':
                            let header = { text: c.query.selectedOperand, value: c.query.rule };
                            switch (c.query.rule) {
                                // case 'committee.service':
                                 // case 'parties.represented':
                                case 'acting.ministries':
                                case 'conf.delegations.visits':
                                case 'electorate':
                                case 'ministerial.appointments':
                                case 'parliamentary.appointments':
                                case 'parliamentary.party.positions':
                                case 'parliamentary.positions':
                                case 'parliamentary.service':
                                case 'party.positions':
                               
                                case 'government.service.state':
                                case 'decorations':
                                case 'honours':
                                case 'government.service.local':
                                case 'military.service':                                    
                                case 'misc.info':
                                case 'occupations':
                                case 'other.positions':
                                case 'publications':
                                case 'quals.work.pre.parliament':
                                case 'shadow.ministry.appointments':
                                case 'committee.service.records':
                                case 'parties.represented.new':
                                case 'party.new':
                                header.sortable = false
                                break;
                            }

                            if (headers.findIndex(h => h.value === header.value) === -1) {
                                headers.push(header);
                            }
                            
                            break;
                        case 'query-builder-group':
                            // recurse
                            calculateExtraHeaders(c.query, headers)
                            break;
                    }
                });
    }

    export default {
        data() { return {         
            results: [],
            totalCount: 0,
            initialSearch: false,
            options: { rowsPerPage: 20 },
            loading: false,
            loadingCsv: false,
            headersSelected: [],
            HandbookAPI: HandbookAPI,
            headersExtra: [],
            error: false,
            rules: [],
            compiledHeaders: [],
            savedSearches: [],
            selectedSavedSearch: null,
            labels: {
                matchTypes: [
                    { id: 'all', label: 'Match all of the below criteria groups'},
                    { id: 'any', label: 'Match any of the below criteria groups'}
                ],
                addRule: 'Add Criteria'
            },
            headers: [
                {
                    text: 'Order',
                    value: 'order'
                },
                {
                    text: 'ID',
                    value: 'id'
                },
                {
                    text: 'Photo',
                    value: 'photo',
                    sortable: false,
                    width: "80px"
                },
                {
                    text: 'PHID',
                    value: 'phid'
                },
                {
                    text: 'Parliament',
                    value: 'parliament'
                },
                {
                    text: 'Given Name',
                    value: 'givenName'
                },
                {
                    text: 'Preferred Name',
                    value: 'preferredName'
                },
                {
                    text: 'Family Name',
                    value: 'familyName'
                },
                {
                    text: 'Middle Names',
                    value: 'middleNames'
                },
                {
                    text: 'Display Name',
                    value: 'displayName'
                },                    
                {
                    text: 'Gender',
                    value: 'gender'
                },
                {
                    text: 'Secondary School',
                    value: 'secondarySchool'
                },
                {
                    text: 'Aboriginal and/or Torres Strait Islander',
                    value: 'firstnations',
                    sortable: false
                },
                {
                    text: 'Place of Birth',
                    value: 'placeOfBirth'
                },
                {
                    text: 'Place of Death',
                    value: 'placeOfDeath'
                },
                {
                    text: 'Country of Birth',
                    value: 'countryOfBirth'
                },
                {                        
                    text: 'State of Birth',
                    value: 'stateOfBirth'
                },
                {
                    text: 'State of Death',
                    value: 'stateOfDeath'
                },
                {
                    text: 'Marital Status',
                    value: 'maritalStatus'
                },
                {
                    text: 'Date Of Birth',
                    value: 'dateOfBirth'
                },
                {
                    text: 'Date Of Death',
                    value: 'dateOfDeath'
                },    
                // {
                //     text: 'Party',
                //     value: 'party'
                // },
                {
                    text: 'Party',
                    value: 'party.new'
                },
                {
                    text: 'State',
                    value: 'state'
                },
                {
                    text: 'Electorate',
                    value: 'electorate'
                },
                {
                    text: 'Member/Senator',
                    value: 'mpOrSenator'
                },
                {
                    text: 'Current',
                    value: 'inCurrentParliament'
                },
                {
                    text: 'Age',
                    value: 'ageInDays'
                },
                {
                    text: 'Days Served',
                    value: 'daysServed'
                },
                {
                    text: 'Years Served',
                    value: 'yearsServed'
                },
                {
                    text: 'Elected Member No',
                    value: 'electedMemberNo'
                },
                {
                    text: 'Elected Senator No',
                    value: 'electedSenatorNo'
                },
                {
                    text: 'Acting Ministries',
                    value: 'acting.ministries'
                },
                // {
                //     text: 'Committee Service',
                //     value: 'committee.service'
                // },
                {
                    text: 'Committee Service',
                    value: 'committee.service.records'
                },
                {
                    text: 'Conferences, Delegations and Visits',
                    value: 'conf.delegations.visits'
                },
                {
                    text: 'Decorations',
                    value: 'decorations'
                },
                {
                    text: 'Honours',
                    value: 'honours'
                },
                {
                    text: 'Local Government Service',
                    value: 'government.service.local'
                },
                {
                    text: 'Military Service',
                    value: 'military.service'
                },
                {
                    text: 'Ministerial Appointments',
                    value: 'ministerial.appointments'
                },
                {
                    text: 'Miscellaneous Information',
                    value: 'misc.info'
                },
                {
                    text: 'Occupations',
                    value: 'occupations'
                },
                {
                    text: 'Other Positions',
                    value: 'other.positions'
                },
                {
                    text: 'Parliamentary Appointments',
                    value: 'parliamentary.appointments'
                },
                {
                    text: 'Parliamentary Party Positions',
                    value: 'parliamentary.party.positions'
                },
                {
                    text: 'Parliamentary Positions',
                    value: 'parliamentary.positions'
                },
                {
                    text: 'Parliamentary Service',
                    value: 'parliamentary.service'
                },
                // {
                //     text: 'Parties Represented',
                //     value: 'parties.represented'
                // },
                {
                    text: 'Parties Represented',
                    value: 'parties.represented.new'
                },
                {
                    text: 'Party Positions',
                    value: 'party.positions'
                },
                {
                    text: 'Publications',
                    value: 'publications'
                },
                {
                    text: 'Qualifications',
                    value: 'quals.work.pre.parliament'
                },
                {
                    text: 'Shadow Ministry Appointments',
                    value: 'shadow.ministry.appointments'
                },
                {
                    text: 'State Territory Government Service',
                    value: 'government.service.state'
                }
            ],
            query: {} 
            }
        },
        computed: {
            headersWithAction: function () {
                return [...this.headersSelected, ...this.headersExtra.filter(he => this.headersSelected.findIndex(h => h.value === he.value) === -1), {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false
                }]
            },
            headersSelectedWithExtra: function () {
                return [...this.headersSelected, ...this.headersExtra.filter(he => this.headersSelected.findIndex(h => h.value === he.value) === -1)];
            },
            sortedRules: function () { return this.rules.slice().sort((a, b) => (a.label > b.label) ? 1 : -1) }
        },
        methods: {
            populateHeaders() {
                this.headersSelected = this.headers.filter(h => defaultColumns.includes(h.value));
            },
            populateQuery() {
                let search = false;
                if (localStorage.headers) {
                    this.headersSelected = JSON.parse(localStorage.headers);
                    search = true;
                }
                if (localStorage.query) {
                    this.query = JSON.parse(localStorage.query);                        
                    search = true;
                }
                if (search) {
                    this.search();
                }
            },
            showError: function () {
                this.error = true;
            },
            helpMessages: function () {
                // if there are no rules, add a helpful message
                const panels = document.querySelectorAll('.depth-2 .panel-body');
                panels.forEach(p => {
                    // if no rules and no text, add it in
                    if (!p.querySelector('.children').textContent && !p.querySelector('.help')) {
                        const node = document.createElement('div');
                        node.classList.add('help');
                        node.append('Please select from the criteria above');
                        p.append(node);
                    }
                    else if (p.querySelector('.children').textContent &&  p.querySelector('.help')) {
                        p.querySelector('.help').remove();
                    }
                });
            },
            search: function () {
                this.initialSearch = true;
                this.loading = true;
                const headers = []
                if ('children' in this.query) {
                    calculateExtraHeaders(this.query, headers);
                }                                                        
                this.headersExtra = [...headers];
                // options adjusted for this vuetify version
                const adjustedOptions = {
                    ...this.options , 
                    sortBy: [ this.options.sortBy ],
                    sortDesc: [ this.options.descending ],
                    itemsPerPage: this.options.rowsPerPage
                };                  
                axios.post('/api/search/Search', { query: this.query, headers: this.headersWithAction, ...adjustedOptions })
                    .then(response => { 
                        this.results = response.data.Results;
                        this.totalCount = response.data.TotalCount;
                        this.loading = false;
                        localStorage.query = JSON.stringify(this.query);
                        localStorage.headers = JSON.stringify(this.headersSelected);
                    })
                    .catch(error => {
                        this.showError();
                        this.loading = false;
                    });
            },
            clear: function() {
                this.query = {
                    logicalOperator: "all",
                    children: [{
                        query: {
                            logicalOperator: "all",
                            children: []
                        },
                        type: 'query-builder-group'
                    }]
                };
                
                this.headersSelected = this.headers.filter(h => defaultColumns.includes(h.value));
                localStorage.removeItem('query');
                localStorage.removeItem('headers');
            },
            addHeaders: function(headers) {
                // add to headers selected, except for those in extra.
                this.headersSelected = headers.filter(e => !this.headersExtra.map(h => h.value).includes(e.value));
            },
            getSavedSearches: function () {
                const url = '/api/search/saved';
                axios.get(url)
                    .then(response => {
                        this.savedSearches = response.data;
                        this.savedSearchesForm = response.data;
                        this.checkForSavedSearch();
                    })
                    .catch(error => {                        
                        this.showError();
                    });
            },
            checkForSavedSearch() {
                // Get the query string from the current URL
                const queryString = window.location.search;                

                // Create a URLSearchParams object from the query string
                const params = new URLSearchParams(queryString);

                // Check if the "id" parameter exists in the query string
                if (params.has('id')) {
                    // If "id" parameter exists, get its value
                    const idValue = params.get('id');
                    this.selectSavedSearch(idValue);
                    this.selectedSavedSearch = parseInt(idValue);
                }
            },
            selectSavedSearch: function (value) {
                if (value) {
                    const search = this.savedSearches.filter(s => s.Id == value)[0];
                    localStorage.setItem('query', search.Query);
                    localStorage.setItem('headers', search.Headers);      

                    let url = new URL(window.location.href);

                    // Set the "id" parameter
                    url.searchParams.set('id', value);

                    // Replace the current URL with the updated URL containing the "id" parameter
                    window.history.replaceState({}, '', url);

                    this.populateQuery();
                }
            },            
            downloadCsv: function () {
                this.loadingCsv = true;
                const url = `${apiUri}/api/search/Csv`;

                // options adjusted for this vuetify version
                const adjustedOptions = {...this.options , sortBy: [ this.options.sortBy ], sortDesc: [ this.options.descending ] };                    
                const data = { query: this.query, headers: this.headersWithAction.filter(h => h.value != 'photo'), ...adjustedOptions, itemsPerPage: -1 };
                // Use XMLHttpRequest instead of Jquery $ajax
                const xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = () => {
                    var a;
                    if (xhttp.readyState === 4 && xhttp.status === 200) {
                        // Trick for making downloadable link
                        a = document.createElement('a');
                        a.href = window.URL.createObjectURL(xhttp.response);
                        // Give filename you wish to download
                        a.download = "HandbookAdvancedSearch_" + moment(new Date()).format("YYYYMMDD") + ".csv";
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                        this.loadingCsv = false;
                    }
                };
                // Post data to URL which handles post request
                xhttp.open("POST", url);
                xhttp.setRequestHeader("Content-Type", "application/json");
                // You should set responseType as blob for binary responses
                xhttp.responseType = 'blob';
                xhttp.send(JSON.stringify(data));
            },
            DATE_FROMTO: function(DateFrom, DateTo, NoServed) {
                if (DateFrom && DateFrom != 'undefined' && DateFrom != 'Undefined' && DateFrom != '1900-01-01' && DateFrom != '1900-01-1') {
                    if (NoServed) {
                        DateFrom = this.formatDate(DateFrom);
                    } else {
                        DateFrom = '. Served: ' + this.formatDate(DateFrom);
                    }                    
                    if (DateTo && DateTo != 'undefined' && DateTo != 'Undefined' && DateTo != '1900-01-01' && DateTo != '1900-01-1') {
                        DateTo = ' to ' + this.formatDate(DateTo);
                    } else {
                        DateTo = ' to present';
                    }
                } else {
                    DateFrom = '';
                    DateTo = '';
                }

                let value = DateFrom + DateTo;
                if (NoServed !== true) {
                    value = value + '.';
                }
                return value;
            },
            DATE_COALESCE(date) {
                if (date && date != '1900-01-01' && date != '1900-01-1') {
                    return date;
                } else {
                    return '';
                }
            },                
            STRING_COALESCE: function(STRING, PREFIX) {
                if (!PREFIX)
                    PREFIX = ''
                if (STRING && STRING != 'undefined' && STRING != 'Undefined' && STRING.trim() != '') {
                    STRING = PREFIX + STRING.trim()
                } else {
                    STRING = ''
                }

                return STRING
            },
            formatDate: function (DATE, PREFIX, OUTPUTFORMAT, trimMonth, INPUTFORMAT) {
                if (!DATE) {
                    return '';
                }
                let format = OUTPUTFORMAT || 'DD.MM.YYYY';
                INPUTFORMAT = INPUTFORMAT || 'DD.MM.YYYY';

                if (!PREFIX) {
                    PREFIX = '';
                }

                if (DATE.match(/1900-[0]1-[0]1/)) {
                    DATE = ''
                } else if (DATE.match(/[0-9]{4}-[0]1-[0]1/) && trimMonth) {
                    DATE = DATE.substring(0, 4)
                }

                if (DATE && DATE != 'undefined' && DATE != 'Undefined' && DATE != '1900-01-01' && DATE != '1900-01-1') {
                    if (DATE.length <= 4) {
                        DATE = PREFIX + DATE;
                    }
                    else if (DATE.length <= 7) {
                        INPUTFORMAT = 'MM.YYYY';
                        DATE = PREFIX + moment(DATE, INPUTFORMAT).format(INPUTFORMAT);
                    } else {
                        DATE = PREFIX + moment(DATE, INPUTFORMAT).format(format);
                    }
                } else {
                    DATE = ''
                }
                return DATE
            }
        },
        filters: {
            boolToYesOrNo: function (value) {
                return value ? 'Yes' : 'No';
            }
        },
        watch: {
            options: {
                handler (newVal, oldVal) {                                                                         
                    if (JSON.stringify(newVal) !== JSON.stringify(oldVal) && oldVal.totalItems != null) {                                                
                        this.search();
                    }                    
                },
                deep: true
            },
            query: function (val) {
                this.$nextTick(() => {
                    // move the add rule field 
                    const addRuleButton = document.querySelector('.rule-actions > .form-group');
                    if (addRuleButton) {
                        const target = addRuleButton.parentElement.parentElement.parentElement.querySelector('.form-group');
                        target.querySelector('.form-control').options[0].text = 'Match all criteria in this group';
                        target.querySelector('.form-control').options[1].text = 'Match any criteria in this group';
                        target.append(addRuleButton);
                    }

                    const unecessaryLabels = document.querySelectorAll('label[for=vqb-match-type]');
                    unecessaryLabels.forEach(l => l.remove());
                        this.helpMessages();
                    })
            }
        },
        async created() {
            // initial setup 

        // should be able to generate these components dynamically.
        // block loading the application until this has been done.
        const response = await axios.get(`/api/search/RecordsOfServiceType`);
        
        this.getSavedSearches();

        const addGroupButton = document.querySelectorAll('.rule-actions .btn')[1];
        document.querySelector('.match-type-container .form-group').append(addGroupButton);
        document.querySelector('.rule-actions .form-group').remove();
        if (!localStorage.query) {
            addGroupButton.click()
        }
        
        const dateRangePanel = {
            template: `
            <span style="display: flex;">
            <v-menu transition="scale-transition" offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on">Dates</v-btn>
                    </template>
            <v-card>

            <parliament-lookup :value="parliament ? parliament.value : null" @input="setParliamentDateRange($event, 1)"/>
            <parliament-lookup v-if="lookups.findIndex(l => l.Field === 'DateStart2') !== -1" @input="setParliamentDateRange($event, 2)"/>

            <ministry-lookup v-if="id !== '999'" :value="ministry ? ministry.value : null" @input="setMinistryDateRange($event, 1)"/>
            <ministry-lookup v-if="id !== '999' && lookups.findIndex(l => l.Field === 'DateStart2') !== -1" @input="setMinistryDateRange($event, 2)"/>                

            <v-menu
                v-for="lookup in lookups.filter(l => l.FieldType === 'Date')" :key="lookup.Header"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y                
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    solo flat
                    :value="getValueDate(lookup.Field)"
                    @input="changeDate($event, lookup.Field)"
                    :label="lookup.Header"
                    placeholder="YYYY-MM-DD"
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
                </template>
                <v-date-picker
                    :value="getValueDate(lookup.Field)"
                    @input="changeDate($event, lookup.Field)"
                no-title
                scrollable>                                
                </v-date-picker>
            </v-menu>
            </v-card>

            </v-menu>
            <v-chip v-for="m in model.filter(m => m.dateValue)" :key="m.field" close @input="clearDate(m.field)"><strong>{{ m.header }}</strong>&nbsp;{{ m.dateValue }}</v-chip>
            </span>
            `,            
            props: ['lookups', 'value', 'id'],
            data: function() {
                return {         
                    model: [],
                    parliament: null,
                    ministry: null
                }
            },
            created() {
                this.model = this
                .lookups.map(x => ({ field: x.Field, value: [], textValue: '', dateValue: this.value.findIndex(v => v.field === x.Field) !== -1 
                    ? this.value.find(v => v.field === x.Field).dateValue : null, header: x.Header }));                
            },
            methods: {          
                changeDate($event, field) {
                    this.parliament = null;
                    this.ministry = null;
                    this.emitValueDate($event, field);
                },
                clearDate(field) {
                    this.parliament = null;
                    this.ministry = null;
                    this.emitValueDate(null, field);
                },
                emitValueDate($event, field) {
                    const index = this.model.findIndex(m => m.field === field);     
                    const newValue = {...this.model[index], dateValue: $event };
                    Vue.set(this.model, index, newValue)
                    this.emitModel();
                },
                getValueDate(field) {
                    return this.model.find(m => m.field === field).dateValue;
                },                
                emitModel() {
                    this.$emit('input', this.model);
                },
                setParliamentDateRange(parliament, set) {
                    this.parliament = parliament;
                    this.ministry = null;
                    switch (set) {
                        case 1:
                            this.emitValueDate(parliament.dateOpening, 'DateStart1');
                            this.emitValueDate(parliament.dateDissolution, 'DateEnd1');
                            break;
                        case 2:
                            this.emitValueDate(parliament.dateOpening, 'DateStart2');
                            this.emitValueDate(parliament.dateDissolution, 'DateEnd2');
                            break;
                    }                    
                },
                setMinistryDateRange(ministry, set) {
                    this.parliament = null;
                    this.ministry = ministry;
                    switch (set) {
                        case 1:
                            this.emitValueDate(ministry.dateStart, 'DateStart1');
                            this.emitValueDate(ministry.dateEnd, 'DateEnd1');
                            break;
                        case 2:
                            this.emitValueDate(ministry.dateStart, 'DateStart2');
                            this.emitValueDate(ministry.dateEnd, 'DateEnd2');
                            break;
                    }                    
                }        
            }
        };
        Vue.component('date-range-panel', dateRangePanel);

        const generatedComponents = response.data.filter(r => r.Name != 'Committee Service' && r.Id != 11).map(r => ({
            template: 
            `<div class="lookup-container" style="display: flex;">
            <v-autocomplete v-for="lookup in lookups.filter(l => l.ReferenceData)" :key="lookup.Field" :loading="loading" :label="lookup.Header" :items="lookup.ReferenceData.map(r => ({ value: r.Id, text: r.Value}))" solo flat multiple chips :value="getValue(lookup.Field)" @input="emitValue($event, lookup.Field)"></v-autocomplete>
            <v-autocomplete v-for="lookup in lookups.filter(l => l.SimpleReferenceDataMulti)" :key="lookup.Field" :loading="loading" :label="lookup.Header" :items="lookup.SimpleReferenceDataMulti" solo multiple chips deletable-chips small-chips :value="getValueTextSimple(lookup.Field)" @input="emitValueTextSimple($event, lookup.Field)"></v-autocomplete>
            <v-combobox v-for="lookup in lookups.filter(l => l.SimpleReferenceData)" :key="lookup.Field" :loading="loading" :label="lookup.Header" :items="lookup.SimpleReferenceData" solo flat :value="getValueSimple(lookup.Field)" @input="emitValueSimple($event, lookup.Field)"></v-combobox>            

            <date-range-panel v-if="!loading" @input=mergeModel($event) id="` + r.Id + `" :lookups="lookups.filter(l => l.FieldType === 'Date')" :value="model.filter(m => m.fieldType === 'Date')"></date-range-panel>

            </div>`,
            props: ["value"],
            data: function () {
                return {
                    loading: true,
                    items: [],
                    lookups: [],
                    model: [],
                    menu: false
                }
            },
            created: function() {
                this.query();
                
            },
            methods: {
                query() {
                    axios.get(`/api/search/recordofservicelookup/${r.Id}`)
                        .then(response => {
                            this.lookups = response.data;
                            if (this.value) {
                                this.model = JSON.parse(this.value);
                            } else {
                                this.model = response.data
                                .map(x => 
                                ({ field: x.Field, value: [], simpleValue: [], textValue: '', dateValue: null, fieldType: x.FieldType }))
                            }
                            this.loading = false;
                        });
                },
                emitValue($event, field) {
                    const index = this.model.findIndex(m => m.field === field);
                    this.model[index].value = $event;
                    this.emitModel();
                },
                emitValueTextSimple($event, field) {
                    const index = this.model.findIndex(m => m.field === field);
                    this.model[index].simpleValue = $event;
                    this.emitModel();
                },
                emitValueSimple($event, field) {
                    const index = this.model.findIndex(m => m.field === field);
                    this.model[index].textValue = $event;
                    this.emitModel();
                },
                emitValueText($event, field) {
                    const index = this.model.findIndex(m => m.field === field);
                    this.model[index].textValue = $event.target.value;
                    this.emitModel();
                },   
                emitValueDate($event, field) {
                    const index = this.model.findIndex(m => m.field === field);
                    this.model[index].dateValue = $event;
                    this.emitModel();
                },
                mergeModel($event) {  
                    $event.forEach(e => {
                        this.emitValueDate(e.dateValue, e.field);
                    });                    
                },
                emitModel() {
                    this.$emit('input', JSON.stringify(this.model));
                },
                getValue(field) {
                    return this.model.find(m => m.field === field).value;
                },
                 getValueTextSimple(field) {
                    return this.model.find(m => m.field === field).simpleValue;
                },
                getValueSimple(field) {
                    return this.model.find(m => m.field === field).textValue;
                },
                getValueDate(field) {
                    return this.model.find(m => m.field === field).dateValue;
                }
            }
        }));

        const rules = response.data.filter(r => r.Name != 'Committee Service' && r.Abbrev != 'party.new' && r.Abbrev != 'parties.represented').map((r, i) => ({
            type: 'custom-component',
            id: r.Abbrev,
            label: r.Name == 'Committee Service Records' ? 'Committee Service' : r.Name,
            operators: ["of"],
            component: generatedComponents[i]
        }));

        this.rules = [
                {
                    type: 'custom-component',
                    id: 'parliament',
                    label: 'Parliament',
                    operators: ['of', 'not of'],
                    component: parliamentLookup
                },                         
                {
                    type: 'custom-component',
                    id: 'phid',
                    label: 'PHID',
                    operators: ["The exact phrase", "Contains"],
                    component: parliamentarianReferenceLookup('phid')
                },
                {
                    type: 'custom-component',
                    id: 'familyName',
                    label: 'Family Name',
                    operators: ["The exact phrase", "Contains"],
                    component: parliamentarianReferenceLookup('familyName')
                },
                {
                    type: 'custom-component',
                    id: 'middleNames',
                    label: 'Middle Names',
                    operators: ["The exact phrase", "Contains"],
                    component: parliamentarianReferenceLookup('middleNames')
                },                    
                {
                    type: 'custom-component',
                    id: 'preferredName',
                    label: 'Preferred Name',
                    operators: ["The exact phrase", "Contains"],
                    component: parliamentarianReferenceLookup('preferredName')
                },
                {
                    type: 'custom-component',
                    id: 'displayName',
                    label: 'Display Name',
                    operators: ["The exact phrase", "Contains"],
                    component: parliamentarianReferenceLookup('displayName')
                },
                {
                    type: 'custom-component',
                    id: 'givenName',
                    label: 'Given Name',
                    operators: ["The exact phrase", "Contains"],
                    component: parliamentarianReferenceLookup('givenName')
                },                                        
                {
                    type: 'select',
                    id: 'mpOrSenator',
                    label: 'Member or Senator',
                    choices: [
                        { label: 'Senator', value: 'senator'},
                        { label: 'Member', value: 'member'}
                    ]
                },
                {
                    type: 'select',
                    id: 'gender',
                    label: 'Gender',
                    operators: ["is"],
                    choices: [
                        { label: "Male", value: "Male" },
                        { label: "Female", value: "Female" },
                    ],
                },
                {
                    type: 'select',
                    id: 'firstnations',
                    label: 'Aboriginal and/or Torres Strait Islander',
                    operators: ["is"],
                    choices: [
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" },
                    ],
                },
                {
                    type: 'numeric',
                    id: 'ageInDays',
                    label: 'Age',
                    operators: ['equals','not equals','less than','less than or equal','greater than','greater than or equals', 'not stated'],
                },
                {
                    type: 'numeric',
                    id: 'yearsServed',
                    label: 'Years Served',
                    operators: ['equals','not equals','less than','less than or equal','greater than','greater than or equals'],
                },
                {
                    type: 'custom-component',
                    id: 'secondarySchool',
                    label: 'Secondary School',
                    operators: ["The exact phrase", "Contains"],
                    component: parliamentarianReferenceLookup('secondarySchool')
                },  
                {
                    type: 'custom-component',
                    id: 'placeOfBirth',
                    label: 'Place of Birth',
                    operators: ["The exact phrase", "Contains"],
                    component: parliamentarianReferenceLookup('placeOfBirth')
                },
                {
                    type: 'custom-component',
                    id: 'placeOfDeath',
                    label: 'Place of Death',
                    operators: ["The exact phrase", "Contains"],
                    component: parliamentarianReferenceLookup('placeOfDeath')
                },                                                              
                {
                    type: 'custom-component',
                    id: 'countryOfBirth',
                    label: 'Country of Birth',
                    operators: ["of", "not of"],
                    component: referenceLookup(3)
                },
                {
                    type: 'custom-component',
                    id: 'stateOfBirth',
                    label: 'State of Birth',
                    operators: ["of", "not of"],
                    component: referenceLookup(4)
                },     
                {
                    type: 'custom-component',
                    id: 'stateOfDeath',
                    label: 'State of Death',
                    operators: ["of", "not of"],
                    component: referenceLookup(4)
                },                                      
                {
                    type: 'custom-component',
                    id: 'maritalStatus',
                    label: 'Marital Status',
                    operators: ["of", "not of"],
                    component: referenceLookup(2)
                },                    
                {
                    type: 'select',
                    id: 'inCurrentParliament',
                    label: 'In current Parliament',
                    choices: [
                        { label: 'Yes', value: 'Yes' },
                        { label: 'No', value: 'No' },
                    ]
                },
                // {
                //     type: 'custom-component',
                //     id: 'party',
                //     label: 'Party',
                //     operators: ["of", "not of"],
                //     component: referenceLookup(12)
                // },
                {
                    type: 'custom-component',
                    id: 'party.new',
                    label: 'Party',
                    operators: ["of", "not of"],
                    component: referenceLookup(1001)
                },
                {
                    type: 'custom-component',
                    id: 'state',
                    label: 'State',
                    operators: ["of", "not of"],
                    component: referenceLookup(4)
                },
                ...rules
            ]

            this.populateHeaders();
            this.populateQuery();
            this.$watch('headersWithAction', function(newVal, oldVal) {                
                if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {                    
                    this.search();
                }                    
            });
        },
        components: {
            VueQueryBuilder,
             Portrait,
        }
    };
</script>
<style>
.vue-query-builder .form-group {
display: flex !important;
align-items: center;
}
.vue-query-builder select {
height: 32px;
padding: 6px 10px; /* The 6px vertically centers text on FF, ignored by Webkit */
background-color: #fff;
border: 1px solid #d1d1d1;
border-radius: 4px;
box-shadow: none;
box-sizing: border-box;
-webkit-appearance: menulist;
margin: 2px;
margin-right: 5px;
display: inline-block;
}

.vue-query-builder button.btn {
display: inline-block;
height: 32px;
padding: 0 20px;
color: #555;
text-align: center;
font-size: 11px;
font-weight: 600;
line-height: 32px;
letter-spacing: 0.1rem;
text-transform: uppercase;
text-decoration: none;
white-space: nowrap;
background-color: transparent;
border-radius: 4px;
border: 1px solid #bbb;
cursor: pointer;
box-sizing: border-box;
margin: 2px;
}
.vue-query-builder .vue-query-builder button.btn:hover {
color: #333;
border-color: #888;
outline: 0;
}

.vue-query-builder .vue-query-builder button.pull-right {
    font-size:18px;
}

/* bootstrap styles */
.vue-query-builder .panel-default {
    border-color: #dddddd;
}

.vue-query-builder .panel {
    margin-bottom: 20px;
    background-color: #ffffff;
    border: 1px solid transparent;
    border-radius: 4px;
    -webkit-box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
    box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
}

.vue-query-builder .panel-default > .panel-heading {
    color: #333333;
    background-color: #f5f5f5;
    border-color: #dddddd;
}

.vue-query-builder .panel-heading {
    padding: 10px 15px;
    border-bottom: 1px solid transparent;
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
}

.vue-query-builder label {
    display: flex !important;
    justify-content: center;
    align-items: center;
    margin-right: .5rem !important;
    margin-bottom: 0;
}

.vue-query-builder .panel-body {
    padding: 15px;
}

.vue-query-builder .close:hover, .close:focus {
    color: #000000;
    text-decoration: none;
    cursor: pointer;
    opacity: 0.5;
    filter: alpha(opacity=50);
}

.vue-query-builder button.close {
    padding: 0;
    cursor: pointer;
    background: transparent;
    border: 0;
    -webkit-appearance: none;
}
.vue-query-builder .pull-right {
    margin-left: auto;
}

.vue-query-builder .pull-right {
    float: right !important;
}
.vue-query-builder .close {
    float: right;
    font-size: 21px;
    font-weight: bold;
    line-height: 1;
    color: #000000;
    text-shadow: 0 1px 0 #ffffff;
    opacity: 0.2;
    filter: alpha(opacity=20);
}
.vue-query-builder .match-type-container {
    display: flex;
}
.vue-query-builder .v-text-field__details {
    display: none !important;
}

.vue-query-builder .v-input {
    flex: 0 1 auto !important;            
}

.vue-query-builder .lookup-container > .v-input {
    margin-left: 5px !important;
}

.vue-query-builder .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    background: white !important;
    border: 1px solid #d1d1d1;
}

.vue-query-builder .form-group > input {
    height: 32px;
    padding: 6px 10px;
    background-color: #fff;
    border: 1px solid #d1d1d1;
    border-radius: 4px;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-appearance: menulist;
    margin: 2px;
    margin-right: 5px;
    display: inline-block;
}
</style>
<style>
    @import
    'https://unpkg.com/vue-query-builder@0.7.1/dist/VueQueryBuilder.css';
</style>
